import { ReactNode, useState } from 'react';
import PopoverMenu from '../PopoverMenu';
import DeleteModal from '../DeleteModal/DeleteModal';
import useOnlineStatus from '@/hooks/useOnlineStatus';
import ArrowUpIcon from '@/assets/icons/arrow-up.svg?react';
import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import styles from './Accordion.module.scss';

interface MenuAccordionProps {
  index: number;
  header: ReactNode;
  children: ReactNode;
  /* eslint-disable no-unused-vars */
  handleEdit?: (index: number) => void;
  handleDelete?: (index: number) => void;
  handleCopy?: (index: number) => void;
  handleAddToSet?: () => void;
  handleHistory?: (index: number) => void;
  /* eslint-enable no-unused-vars */
  showMenu?: boolean;
  triggerDeleteModal?: boolean;
  showHistory?: boolean; // need a flag since it depends on user permissions
}

function MenuAccordion({ index, header, children, handleEdit, handleDelete, handleCopy, handleAddToSet, showMenu = true, triggerDeleteModal = true, handleHistory, showHistory }: MenuAccordionProps) {
  const isOnline = useOnlineStatus();
  const [isOpen, setIsOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const onDelete = () => {
    if (triggerDeleteModal) setShowDeleteModal(true);
    else handleDelete?.(index);
  };

  return (
    <div className={styles.accordion} data-testid="tourbag-club-accordion">
      <div className={styles.header}>
        <span className={styles.headerText} onClick={() => setIsOpen((prev) => !prev)}>
          {isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
          {header}
        </span>
        {/* Block specific actions to online usage only */}
        {showMenu && (
          <PopoverMenu
            index={index}
            onEdit={handleEdit ? () => handleEdit(index) : undefined}
            onDelete={isOnline ? onDelete : undefined}
            onCopy={handleCopy ? () => handleCopy(index) : undefined}
            onAddToSet={isOnline ? handleAddToSet : undefined}
            onHistory={handleHistory}
            showHistory={isOnline && showHistory}
          />
        )}
      </div>
      {isOpen && children}
      {/* // TODO: Remove delete modal from MenuAccordion */}
      {showDeleteModal && <DeleteModal handleConfirm={() => handleDelete?.(index)} handleCancel={() => setShowDeleteModal(false)} />}
    </div>
  );
}

export default MenuAccordion;
